import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import routes from '../../config/routes';
import Page from '../../components/Page';
import PublicRoute from '../../components/PublicRoute';
import PrivateRoute from '../../components/PrivateRoute';
import ScrollToTop from '../../components/ScrollToTop';
import { useSessionQuery } from '../../store/api-generated';

const Router: React.FC = () => {
  useSessionQuery();

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        {Object.entries(routes).map(([pageKey, pageConfig]) => {
          const { component: Component } = pageConfig;
          const auth = 'auth' in pageConfig && pageConfig.auth;

          if (auth === 'public') {
            return (
              <PublicRoute
                key={`route-${pageKey}`}
                path={[pageConfig.path]}
                exact
                Component={Component}
              />
            );
          }

          if (auth === 'private') {
            return (
              <PrivateRoute
                key={`route-${pageKey}`}
                path={[pageConfig.path]}
                exact
                Component={Component}
              />
            );
          }

          return (
            <Route
              key={`route-${pageKey}`}
              path={[pageConfig.path]}
              exact
            >
              <Page>
                <Component />
              </Page>
            </Route>
          );
        })}
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
